import React from "react";
import IndexColGroup from "./IndexColGroup";
import { Button, Row, Space } from "antd";
import { PlusOutlined, MinusCircleFilled } from "@ant-design/icons";
import styles from "./styles.module.css";

export default function IndexColList(props) {
  const elmarray = [];
  elmarray.push(
    <IndexColGroup
      key={1}
      cols={props.selectedCols.filter((rt) => rt.type === 1)}
      allIndexes={props.allIndexes}
      type={1}
      updateColumn={props.updateColumn}
      getColumns={props.getColumns}
      addColumn={props.addColumn}
      removeColumn={props.removeColumn}
    />
  );
  if (props.selectedCols.filter((rt) => rt.type === 1).length > 0) {
    elmarray.push(
      <td
        key="add_1"
        className={styles.index_icon_col_td}
        style={{ borderRight: "1px solid rgba(0, 0, 0, 0.65)" }}
      >
        <div>
          <Button
            style={{ paddingTop: "16px" }}
            onClick={() => props.addColumn(1)}
            icon={<PlusOutlined />}
            type="link"
          ></Button>
        </div>
      </td>
    );
  }
  elmarray.push(
    <IndexColGroup
      key={2}
      cols={props.selectedCols.filter((rt) => rt.type === 2)}
      allIndexes={props.allIndexes}
      type={2}
      updateColumn={props.updateColumn}
      getColumns={props.getColumns}
      addColumn={props.addColumn}
      removeColumn={props.removeColumn}
    />
  );
  if (props.selectedCols.filter((rt) => rt.type === 2).length > 0) {
    elmarray.push(
      <td key="add_2" className={styles.index_icon_col_td}>
        <Button
          style={{ paddingTop: "16px" }}
          onClick={() => props.addColumn(2)}
          icon={<PlusOutlined />}
          type="link"
        ></Button>
      </td>
    );
  }
  return elmarray;

  /* <Button onClick={()=>props.addColumn(2)}>Add Column</Button> */
  /* <Button onClick={()=>props.removeColumn(3)}>remove column</Button> */
}
